window.addEventListener('load', () => {
  const triggers = document.querySelectorAll('[data-enquire-trigger]');
  if(!triggers.length) return;

  console.log(triggers);

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const modal = trigger.closest('.product-buttons')?.querySelector('[data-enquire-modal]');
      if(!modal) return;
      modal.classList.toggle('open');
    });
  });
});